import SelectA11yDo from "../../../../../../packages/design-system/select/constellation/index/images/select-a11y-do.png";
import SelectA11yDont from "../../../../../../packages/design-system/select/constellation/index/images/select-a11y-dont.png";
import * as React from 'react';
export default {
  SelectA11yDo,
  SelectA11yDont,
  React
};